<h2>FAI RICERCA?</h2>
<p>
	La De Cifris collabora con più di 27 università/centri di ricerca con
	l’obiettivo di promuovere lo studio e la ricerca della crittografia, con
	l’ideazione/sviluppo di nuovi cifrari. <br>
	Tra le attività principali si segnalano:
</p>
<ul>
	<li>
		L'organizzazione di convegni su temi specifici o
		di tipo generale. Finora stati organizzati due tipi di convegni, uno sulla
		crittografia post-quantum e un altro sulla tecnologia blockchain,
		e una conferenza in collaborazione con il gruppo UMI “Crittografia e
		Codici”.
	</li>
	<li>
		La De Cifris gestisce due collane di libri, “Collectio Ciphrarum” e
		“Crittografia”, la prima dedicata ad atti di convegni, l’altra
		di più ampio respiro, e nel breve futuro una rivista “De Cifris
		Experimental Journal”. Tra i volumi pubblicati c’è il “libro delle 100
		tesi” in cui sono stati raccolti brevi riassunti di 100 tesi universitarie di
		Crittografia e Teoria dei Codici per laureati in Italia nel periodo 2008-
		2017.
	</li>
	<li>
		La De Cifris si propone di aiutare nella fase di stesura ed elaborazione
		di progetti di ricerca presentati a bandi di interesse nazionale e
		internazionale, con il sostegno degli esperti dell'associazione.
	</li>
</ul>